import { cn, initialsFrom } from '@/lib/utils';

interface UserAvatarProps {
  name?: string | null | undefined;
  email?: string | null | undefined;
  avatarAttachmentId?: string | null | undefined;
  size?: number;
  className?: string;
  title?: string;
}

export function UserAvatar({
  name,
  email,
  avatarAttachmentId,
  size = 32,
  className,
  title,
}: UserAvatarProps) {
  const label = name || email || 'User';
  const tooltip = title ?? label;
  if (avatarAttachmentId) {
    return (
      <img
        src={`/api/uploads/${avatarAttachmentId}?variant=thumbnail`}
        alt={label}
        title={tooltip}
        width={size}
        height={size}
        style={{ width: size, height: size }}
        className={cn('rounded-full border bg-muted object-cover', className)}
      />
    );
  }
  return (
    <div
      title={tooltip}
      style={{ width: size, height: size, fontSize: Math.max(10, size * 0.4) }}
      className={cn(
        'grid place-items-center rounded-full bg-primary text-primary-foreground font-semibold',
        className,
      )}
    >
      {initialsFrom(name ?? '', email ?? undefined)}
    </div>
  );
}
